
  <div class="d-flex" id="wrapper" >

    <!-- Sidebar -->
    <div class="for-color" id="sidebar-wrapper">
      <!-- <div class="sidebar-heading"> </div> -->
      <div class="list-group list-group-flush">
      
            <ul class="accordion mt-1">
              <li><mdb-icon class="d-block d-md-none mt-2" style="z-index:999" id="menu-toggle1" fas icon="bars"></mdb-icon></li>
              <li><img class="img-fluid mb-4 mx-3" src="assets/images/glamatek_logo.png"></li>
              <li>
                <a class="toggle tab" href="javascript:void(0);"><img class="img-fluid" src="assets/images/calendar.png">
                  Booking
                  <mdb-icon fas icon="angle-down"></mdb-icon>
                </a>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                </ul>
                <li class="li-title">Booking</li>
                <ul class="inside-ul"> 
                  <li class="sub-tag" routerLink="daily">Calender</li>
                  <li class="sub-tag" routerLink="book">Booking</li>
                  <li class="sub-tag" routerLink="home" >Home</li>
              </ul>                
                </ul>
                <ul class="inner">
                  <li class="li-title">Clients</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                
                </ul>
                </ul>                
              </li>
              <li>
                <a class="toggle tab" href="javascript:void(0);"><img class="img-fluid" src="assets/images/calendar.png">
                  Transactions
                  <mdb-icon fas icon="angle-down"></mdb-icon>
                </a>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                </ul>
                <li class="li-title">Booking</li>
                <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
              </ul>                
                </ul>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                
                </ul>
                </ul>                
              </li>
              <li>
                <a class="toggle tab" href="javascript:void(0);"><img class="img-fluid" src="assets/images/calendar.png">
                  Employees
                  <mdb-icon fas icon="angle-down"></mdb-icon>
                </a>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                </ul>
                <li class="li-title">Booking</li>
                <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
              </ul>                
                </ul>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                
                </ul>
                </ul>                
              </li>
              <li>
                <a class="toggle tab" href="javascript:void(0);"><img class="img-fluid" src="assets/images/calendar.png">
                  Booking
                  <mdb-icon fas icon="angle-down"></mdb-icon>
                </a>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                </ul>
                <li class="li-title">Booking</li>
                <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
              </ul>                
                </ul>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                
                </ul>
                </ul>                
              </li>   
              <li>
                <a class="toggle tab" href="javascript:void(0);"><img class="img-fluid" src="assets/images/calendar.png">
                  Stock
                  <mdb-icon fas icon="angle-down"></mdb-icon>
                </a>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                </ul>
                <li class="li-title">Booking</li>
                <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
              </ul>                
                </ul>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                
                </ul>
                </ul>                
              </li>   
              <li>
                <a class="toggle tab" href="javascript:void(0);"><img class="img-fluid" src="assets/images/calendar.png">
                  Marketing
                  <mdb-icon fas icon="angle-down"></mdb-icon>
                </a>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                </ul>
                <li class="li-title">Booking</li>
                <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
              </ul>                
                </ul>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                
                </ul>
                </ul>                
              </li>   
              <li>
                <a class="toggle tab" href="javascript:void(0);"><img class="img-fluid" src="assets/images/calendar.png">
                  Suppliers
                  <mdb-icon fas icon="angle-down"></mdb-icon>
                </a>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                </ul>
                <li class="li-title">Booking</li>
                <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
              </ul>                
                </ul>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                
                </ul>
                </ul>                
              </li>   
              <li>
                <a class="toggle tab" href="javascript:void(0);"><img class="img-fluid" src="assets/images/calendar.png">
                  Admin
                  <mdb-icon fas icon="angle-down"></mdb-icon>
                </a>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                </ul>
                <li class="li-title">Booking</li>
                <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
              </ul>                
                </ul>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                
                </ul>
                </ul>                
              </li>
              <li>
                <a class="toggle tab" href="javascript:void(0);"><img class="img-fluid" src="assets/images/calendar.png">
                  Reports
                  <mdb-icon fas icon="angle-down"></mdb-icon>
                </a>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                </ul>
                <li class="li-title">Booking</li>
                <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
              </ul>                
                </ul>
                <ul class="inner">
                  <li class="li-title">Booking</li>
                  <ul class="inside-ul"> 
                    <li class="sub-tag" routerLink="daily">Calender</li>
                    <li class="sub-tag" routerLink="book">Booking</li>
                    <li class="sub-tag" routerLink="home" >Home</li>
                
                </ul>
                </ul>                
              </li>                                                                                                                                                                                                       
            </ul>
      </div>
    </div>
    <!-- /#sidebar-wrapper -->

    <!-- Page Content -->
    <div class="" id="page-content-wrapper">

      <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom py-3">
        <mdb-icon class="d-block d-lg-none " id="menu-toggle" fas icon="bars"></mdb-icon>

        <nav class="nav text-white ml-auto nav-m pr-2">

          <a class="nav-link hvr-grow" href="#">
            <span class="count">1</span>
            <img src="assets/images/message.png">
          </a>

          <a class="nav-link hvr-grow" routerLink="book">
            <span class="count">1</span>
            <img src="assets/images/bell.png">
          </a>

          <a class="nav-link hvr-grow" href="#">
            <img src="assets/images/gear.png">
          </a>  

          <div class="btn-group profile-list" mdbDropdown>
            <ul class="list-inline" mdbDropdownToggle>
              <li class="list-inline-item font-weight-bold"><h6>English</h6></li>
              <li class="list-inline-item mx-1"><mdb-icon  fas icon="angle-down"></mdb-icon></li>
            </ul>
            <div class="dropdown-menu dropdown-menu-left dropdown-primary">
              <a class="dropdown-item">English</a>
              <a class="dropdown-item">Arabic</a>
            </div>
          </div>           

          <div class="btn-group profile-list" mdbDropdown>
            <ul class="list-inline" mdbDropdownToggle>
              <li class="list-inline-item"><img class="img-fluid profile-img" src="assets/images/profile.jpg"></li>
              <li class="list-inline-item font-weight-bold"><h6 class="d-none d-sm-block
                ">Waleed Gamal</h6></li>
              <li class="list-inline-item mx-1"><mdb-icon class="d-none d-sm-block
                " fas icon="angle-down"></mdb-icon></li>
            </ul>
            <div class="dropdown-menu dropdown-menu-right dropdown-primary">
              <a class="dropdown-item">Edit profile</a>
              <a class="dropdown-item" >Log out</a>
            </div>
          </div>  
          
          

        </nav>

        <!-- <div class="collapse navbar-collapse">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item active">
              <a class="nav-link" routerLink="book">Book <span class="sr-only">(current)</span></a>
            </li>
 
          </ul>
        </div> -->
        
      </nav>

      <div class="auto-screen">
        <router-outlet></router-outlet>        
      </div>
    </div>
    <!-- /#page-content-wrapper -->
 
  </div>


